import { useState, useEffect } from 'react';
import { faqService, FAQ } from '@/services/cms.service';

export const useFAQs = () => {
  const [faqs, setFaqs] = useState<FAQ[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadFAQs = async () => {
      try {
        setLoading(true);
        // Utiliser l'endpoint public qui retourne uniquement les FAQ publiées
        const data = await faqService.getPublished();
        setFaqs(data);
        setError(null);
      } catch (err) {
        console.error('Erreur lors du chargement des FAQ:', err);
        setError(err instanceof Error ? err.message : 'Erreur lors du chargement des FAQ');
      } finally {
        setLoading(false);
      }
    };

    loadFAQs();
  }, []);

  return { faqs, loading, error };
};

